// home-page.js: browser entry for the topic index. Bundled by esbuild → dist/assets/b/home-<hash>.js.
// Fills each lesson's two chips from stored progress (progress.js): score of its last study
// answers and days since practised, each coloured on its own; untried shows both poor. Adds
// "tried" counts per section and the last mock-exam result. Toggles the index between the
// logical (syllabus) and A-Z lists, remembering the choice. No JS or storage = static logical index.

import { load, save } from './store.js';
import { STORE, WINDOW, summarize, daysAgo } from './progress.js';
import { SECTION_LABEL } from './sections.js';
import { el } from './el.js';

const $ = (id) => document.getElementById(id);
const chip = ({ text, band }, title) => el('span', { className: `chip ${band}`, textContent: text, title });

function render() {
  const now = Date.now();
  const progress = load(STORE.lessons, {});
  document.querySelectorAll('[data-lesson]').forEach((slot) => {
    const { score, age } = summarize(progress[slot.dataset.lesson], now);
    slot.replaceChildren(chip(score, `right of last ${WINDOW} answers`), chip(age, 'days since practised'));
  });
  document.querySelectorAll('[data-tried]').forEach((count) => {
    const lessons = [...count.closest('section').querySelectorAll('.seq [data-lesson]')];
    count.textContent = `${lessons.filter((s) => progress[s.dataset.lesson]).length}/${lessons.length} tried`;
  });
  const exam = load(STORE.exam, {});
  $('last-exam').replaceChildren(
    ...(exam.t
      ? ['Last mock: ', chip({ text: `${exam.pct}% ${exam.pass ? 'PASS' : 'FAIL'}`, band: exam.pass ? 'good' : 'poor' }),
         ` ${daysAgo(exam.t, now)}d ago · weakest ${SECTION_LABEL[exam.weakest] ?? exam.weakest}`]
      : []),
  );
}

function reset() {
  if (!confirm('Clear all lesson and mock-exam progress in this browser?')) return;
  Object.values(STORE).forEach((name) => save(name, {}));
  render();
}

// Kept outside STORE so resetting progress leaves the chosen order alone.
const VIEW = 'view';
function showView(alpha) {
  $('lesson-index').classList.toggle('by-alpha', alpha);
  $('view-toggle').querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.alpha === String(alpha))));
}

render();
showView(load(VIEW, {}).alpha === true);
$('view-toggle').onclick = ({ target }) => {
  if (!target.dataset.alpha) return;
  const alpha = target.dataset.alpha === 'true';
  showView(alpha);
  save(VIEW, { alpha });
};
['progress-key', 'view-toggle', 'reset-progress'].forEach((id) => $(id).classList.remove('hidden'));
$('reset-progress').onclick = reset;
